module.exports = __webpack_public_path__ + "media/4x3/ao-8b6f2ec2.svg";